if ($('.js-data-table-event-results').length) {
    function returnDataTableEventResultsOptions(dataArray) {
        return {
            data: dataArray,
            order: [],
            columns: [
                {
                    data: 'Name',
                    /* in combine with css styles added icon favorite */
                    /* to first column of the row */
                    render: function (data, type, row, meta) {
                        return `<span class="iconVideo"></span><span class="rowFavorite ${
                            row.Favorite === 'true' ? 'favorite' : ''
                        }">${createLargeDataTooltipLayout(
                            data,
                            undefined,
                            true
                        )}</span>`;
                    },
                },
                { data: 'BIB' },
                {
                    data: 'Course',
                },
                {
                    data: 'Run',
                    render: function (data, type, row, meta) {
                        return `<span>${row.Course} ${data}</span>`;
                    },
                },
                { data: 'Class' },
                {
                    data: 'Team',
                    createdCell: function (td, cellData, rowData, colIndex) {
                        createLargeDataTooltipLayout(cellData, td);
                    },
                },
                { data: 'Gender' },
                {
                    data: 'Time',
                    type: 'time',
                },
                { data: 'Year' },
                { data: 'Type' },
                { data: 'Favorite' },
            ],
            columnDefs: [
                {
                    target: 2,
                    visible: false,
                    searchable: true,
                },
                {
                    target: 8,
                    visible: false,
                    searchable: true,
                },
                {
                    target: 9,
                    visible: false,
                    searchable: true,
                },
                {
                    target: 10,
                    visible: false,
                    searchable: true,
                },
            ],
            scrollX: true,
            fixedColumns: {
                leftColumns: 1,
            },
            search: {
                caseInsensitive: true,
            },
            // bDestroy - enable rerender table with new data array by event.
            bDestroy: true,
            pageLength: 15,
            layout: {
                top2Start: {
                    className: 'dt-search-cell',
                    features: function () {
                        const layout = `<div class="form-item-wrap form-item-wrap--search-built-in js-form-item-wrap-search">
                            <input id='search-field' type="text" class='form-item form-item--search-built-in js-main-search js-search-custom' placeholder='Quick search' value=''>
                        <button class="btn-search-clear js-btn-search-clear" type='button' data-target='search-field'></button>
                        </div>`;

                        return layout;
                    },
                },
                top2End: {
                    rowClass: 'dt-filters-row dt-filters-row--search-built-in',
                    className:
                        'dt-filters-cell dt-filters-cell--search-built-in',
                    features: function () {
                        let toolbar = `<div class="dt-filters-container">
                            <div class='dc js-dt-filters-container'></div>
                            <div class="btn-reset-all-desktop-wrapper hidden-flex js-dt-reset-all-cell">
                                <button type='button' class='btn-reset-all fz-12-16 fw-600 bg-c-transparent c-gray-6 c-dark-hover js-reset-all-btn'>
                                    <span>Reset all</span>
                                </button>
                            </div>
                        </div>
                        `;
                        return toolbar;
                    },
                },
                top1Start: {
                    rowClass: 'dt-filters-row-mobile',
                    className: 'dt-filters-cell-mobile',
                    features: function () {
                        let layout = `<div class="df fsc gap-16">
                            <button class='btn-filter' type='button' data-open='mdl-filters'>
                                <span>Filters</span>
                            </button>
                            <div class="hidden-block js-dt-reset-all-cell">
                                <button type='button' class='btn-reset-all fz-12-16 fw-600 bg-c-transparent c-gray-6 c-dark-hover js-reset-all-btn'>
                                    <span>Reset all</span>
                                </button>
                            </div>
                        </div>`;

                        return layout;
                    },
                },
                topStart: {
                    info: {
                        text: 'VIDEOS: _TOTAL_',
                        empty: 'VIDEOS: _TOTAL_',
                        search: '',
                    },
                },
                topEnd: {
                    rowClass: 'dt-results-row',
                    className: 'dt-sort-by-cell',
                    features: function () {
                        const sortByData = [
                            'Name',
                            'BIB',
                            'Run',
                            'Class',
                            'Team',
                            'Gender',
                            'Time',
                        ];

                        const layout = `<div class="table-sort-mobile js-table-sort-mobile-container">
                            <button class="table-sort-mobile__button js-sort-by-button" data-drop="sort-by-dropdown">
                                <span class="df">
                                    Sort by<span class="hidden-flex gap-8 js-sort-by-container">:<span class="fw-400 js-sort-by-text"></span></span>
                                </span>
                            </button>
                            <div id="sort-by-dropdown" class="table-sort-mobile__dropdown dropdown under left js-sort-by-dropdown js-dropdown">
                            ${sortByData
                                .map(
                                    (item) => `
                                    <button class="table-sort-mobile__option js-sort-by-mobile js-sort-by-mobile-${item.toLowerCase()}" type="button">
                                        <span class="js-sort-by-value">${item}</span>
                                        <span class="table-sort-mobile__order"></span>
                                    </button>
                                `
                                )
                                .join('')}
                            </div>
                        </div>`;
                        return layout;
                    },
                },
                bottomStart: null,
                bottomEnd: {
                    rowClass: 'dt-paging-row',
                    className: 'dt-paging-cell',
                    features: {
                        paging: {
                            type: 'simple_numbers',
                            buttons: 6,
                        },
                    },
                },
            },
            createdRow: function (row, data, dataIndex) {
                $(row).each(function (index) {
                    $(this)
                        .attr('data-href', data.Link)
                        .addClass('js-dt-row-clickable');
                });
            },
            initComplete: function () {
                // Add custom class to search input
                $('.dt-search').addClass(
                    'form-item-wrap form-item-wrap--search'
                );

                const filtersContainer = $('.js-dt-filters-container');
                filtersContainer.empty();

                this.api()
                    .columns([4, 2, 5, 8, 6])
                    .every(function (colIdx) {
                        let title = this.column(colIdx).title();
                        let column = this;

                        $(
                            `<div class="form-item-wrap form-item-wrap--no-border form-item-wrap--table-filter js-select-filter-wrap order${colIdx}"></div>`
                        ).appendTo(filtersContainer);

                        let selectBase = $(
                            `<select id="${colIdx}" class="js-select2-datatable" multiple data-placeholder="${title}: All"></select>`
                        )
                            .appendTo(
                                $(`.js-select-filter-wrap.order${colIdx}`)
                            )
                            .on('change', function () {
                                //Get the "text" property from each selected data
                                //regex escape the value and store in array
                                var data = $.map(
                                    $(this).select2('data'),
                                    function (value, key) {
                                        return value.text
                                            ? '^' +
                                                  $.fn.dataTable.util.escapeRegex(
                                                      value.text
                                                  ) +
                                                  '$'
                                            : null;
                                    }
                                );

                                //if no data selected use ""
                                if (data.length === 0) {
                                    data = [''];
                                }

                                //join array into string with regex or (|)
                                var val = data.join('|');

                                //search for the option(s) selected
                                column
                                    .search(val ? val : '', true, false)
                                    .draw();
                            });

                        let uniqueOptions = 0;

                        column
                            .data()
                            .unique()
                            .sort()
                            .each(function (d, j) {
                                uniqueOptions += 1;
                                const layout =
                                    '<option value="' +
                                    d +
                                    '">' +
                                    d +
                                    '</option>';
                                if (colIdx == 7) {
                                    selectBase.prepend(layout);
                                } else {
                                    selectBase.append(layout);
                                }
                            });

                        $.fn.select2.amd.require(
                            [
                                'select2/utils',
                                'select2/dropdown',
                                'select2/dropdown/attachContainer',
                                'select2/dropdown/search',
                                'select2/dropdown/attachBody',
                            ],
                            function (
                                Utils,
                                Dropdown,
                                DropdownSearch,
                                AttachBody,
                                DropdownAdapter,
                                AttachContainer
                            ) {
                                let $select = $(
                                    '.js-select2-datatable'
                                ).select2({
                                    closeOnSelect: false,
                                    width: '100%',
                                    minimumResultsForSearch: 5,
                                    /* dropdown without search field */
                                    // dropdownAdapter: Utils.Decorate(DropdownAdapter, AttachContainer)
                                    dropdownAdapter: Utils.Decorate(
                                        Utils.Decorate(
                                            Dropdown,
                                            DropdownSearch
                                        ),
                                        AttachBody
                                    ),
                                });

                                $select.on('change', function (e) {
                                    var $selection = $(this)
                                        .closest('.js-select-filter-wrap')
                                        .find('.select2-selection__rendered');
                                    var count = $(this).val().length;
                                    var columnTitle = $($(this)[0])
                                        .attr('data-placeholder')
                                        .split(':')[0];

                                    if (count > 1) {
                                        $selection.html(
                                            `<span class="selected-options">${columnTitle}: (${count})</span>`
                                        );
                                    } else if (count === 1) {
                                        $selection.html(
                                            `<span class="selected-option">${columnTitle}: ${
                                                $(this).val()[0]
                                            }</span>`
                                        );
                                    } else {
                                        $selection.html(``);
                                    }

                                    setSelect2PlaceholderWidth();
                                });

                                setSelect2PlaceholderWidth();
                            }
                        );

                        if (uniqueOptions < 12) {
                            selectBase
                                .closest('.form-item-wrap')
                                .addClass('hide-search');
                        }
                    });

                displayLargeDataTooltip();
                addCellLabel();
                setInfoResultsIntoMobileContainer(
                    this.api().page.info().recordsDisplay
                );
                setResetAllControlsState();

                setTimeout(() => {
                    $('.js-datatable-loader').removeClass('active');
                    $('.js-datatable-wrap').addClass('active');

                    setTimeout(() => {
                        window.dispatchEvent(new Event('resize'));
                    }, 0);
                }, 150);
            },
        };
    }

    let tableEventResults = $('.js-data-table-event-results').DataTable(
        returnDataTableEventResultsOptions(eventSearchResultsDataArray)
    );

    fireFunctionOnDataTablesNativeEvents(tableEventResults);

    customSearch(tableEventResults);

    /* HELPER FUNCTIONS */

    /* Reset all results */
    $(document).on('click', '.js-reset-all-btn', function () {
        resetAllResults();
        setTimeout(() => {
            tableEventResults.draw();
        }, 0);
    });

    /* SORT BY MOBILE */
    $(document).on('click', '.js-sort-by-mobile-name', function () {
        setSortByOrder(tableEventResults, 0, $(this));
    });
    $(document).on('click', '.js-sort-by-mobile-bib', function () {
        setSortByOrder(tableEventResults, 1, $(this));
    });
    $(document).on('click', '.js-sort-by-mobile-course', function () {
        setSortByOrder(tableEventResults, 2, $(this));
    });
    $(document).on('click', '.js-sort-by-mobile-run', function () {
        setSortByOrder(tableEventResults, 3, $(this));
    });
    $(document).on('click', '.js-sort-by-mobile-class', function () {
        setSortByOrder(tableEventResults, 4, $(this));
    });
    $(document).on('click', '.js-sort-by-mobile-team', function () {
        setSortByOrder(tableEventResults, 5, $(this));
    });
    $(document).on('click', '.js-sort-by-mobile-gender', function () {
        setSortByOrder(tableEventResults, 6, $(this));
    });
    $(document).on('click', '.js-sort-by-mobile-time', function () {
        setSortByOrder(tableEventResults, 7, $(this));
    });

    /* /HELPER FUNCTIONS */
}
